var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('contact-list',{attrs:{"title":_vm.contactData.title,"contacts":_vm.imQyhContactData}}),_vm._v(" "),_c('team-list',{attrs:{"title":_vm.groupData.title,"im-teams":_vm.groupData.teams}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26424ac5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/im/right/contacts/Contacts.vue
// module id = null
// module chunks = 